import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AppService } from '../../../../services/app.service';
import { RoleEnvelope } from '../../../../models/net/envelope/role-envelope';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { RoleService } from '../../../../services/identity/roles/role.service';
import { EditorComponent } from '../../../base/editor/editor.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { HistoryComponent } from '../../../fragments/history/history.component';

@Component({
    selector: 'app-role',
    templateUrl: './role.component.html',
    styleUrls: ['./role.component.css', '../../../../app.component.css']
})

export class RoleComponent extends EditorComponent implements AfterViewInit {

    @ViewChild("appHistory") appHistory!: HistoryComponent;

    public constructor(public override appService: AppService,
                       public override itemService: RoleService,
                       public override route: ActivatedRoute,
                       public override location: Location) {

        super(appService, itemService, route, location, "role", "roles");
    }

    public override handleEditMode = (): void => {

        this.appService.navigateTo("role/" + this.itemId.toString(), "");
    }

    public override initializeEnvelope = (envelope: RoleEnvelope | null): void => {

        super.initializeEnvelope(envelope);

        this.itemEnvelope = new RoleEnvelope(envelope);
        this.itemEnvelopeSnapshot = this.appService.cloneObject(this.itemEnvelope);
    }

    public onTabChange(event: MatTabChangeEvent) {

        if (event.index == 0 && !this.isRevisionListLoaded) {

        }
    }

    public ngAfterViewInit() {

        this.appHistory.searchRevisions();
    }
}
